import React, { useState, useEffect } from "react";
import { Input, Button, List } from "antd";
import "./DriverFilter.css";
import { useTranslation } from "react-i18next";
import { isColorDark } from "../sideBar/sideBar";

export default function DriverFilter({ tags = [], names = [], onFilter }) {
  const [query, setQuery] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const { t } = useTranslation();
  const primaryColor = "var(--chakra-colors-gandolapp-500)";
  const buttonTextColor = isColorDark(primaryColor) ? "white" : "black";

  useEffect(() => {
    onFilter(query);
  }, [query]);

  const handleClear = () => {
    setQuery("");
    onFilter("");
  };

  const allSuggestions = [...new Set([...tags, ...names])];
  const filteredSuggestions = allSuggestions.filter((item) =>
    item?.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="driver-filter-box" style={{ position: "relative", width: "fit-content" }}>
      <div className="driver-filter-row">
        <Input
          className="driver-filter-input"
          placeholder={t("driverFilter.input")}
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setShowSuggestions(true);
          }}
        />
        <Button
          size="small"
          onClick={handleClear}
          style={{
            background: primaryColor,
            color: buttonTextColor,
            borderRadius: 5,
          }}
        >
          {t("driverFilter.button")}
        </Button>
      </div>

      {showSuggestions && query && filteredSuggestions.length > 0 && (
        <List
          className="driver-filter-suggestions"
          dataSource={filteredSuggestions}
          renderItem={(item, index) => (
            <List.Item
              key={index}
              className="driver-filter-suggestion-item"
              onClick={() => {
                setQuery(item);
                setShowSuggestions(false);
              }}
            >
              {item}
            </List.Item>
          )}
        />
      )}
    </div>
  );
}
